module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('list', {
    attrs: {
      "listTitle": _vm.$t('logs.label'),
      "filterTitle": "Filtro",
      "loading": _vm.loading,
      "total": _vm.logsTotal,
      "emitChangeOnCreated": false
    },
    on: {
      "change": _vm.onChange,
      "loadMore": _vm.loadMore,
      "clearFilters": _vm.clearFilters
    }
  }, [_c('template', {
    slot: "filters"
  }, [_c('form-group', {
    attrs: {
      "label": _vm.$t('identifier.label')
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.options.identifier),
      expression: "options.identifier"
    }],
    staticClass: "form-input",
    domProps: {
      "value": (_vm.options.identifier)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.options, "identifier", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('form-group', {
    attrs: {
      "label": _vm.$t('scope.label')
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.options.scope),
      expression: "options.scope"
    }],
    staticClass: "form-select",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.options, "scope", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    domProps: {
      "value": null
    }
  }, [_vm._v("Todos")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "order*"
    }
  }, [_vm._v(_vm._s(_vm.$t('order.label')))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "product*"
    }
  }, [_vm._v(_vm._s(_vm.$t('product.label')))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "price*"
    }
  }, [_vm._v(_vm._s(_vm.$t('price.label')))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "stock*"
    }
  }, [_vm._v(_vm._s(_vm.$t('stock.label')))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "feed*"
    }
  }, [_vm._v(_vm._s(_vm.$t('feed.label')))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "token*"
    }
  }, [_vm._v(_vm._s(_vm.$t('token.label')))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "user_action*"
    }
  }, [_vm._v(_vm._s(_vm.$t('user_action.label')))])])]), _vm._v(" "), _c('form-group', {
    attrs: {
      "label": _vm.$t('module.label')
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.options.moduleOption),
      expression: "options.moduleOption"
    }],
    staticClass: "form-select",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.options, "moduleOption", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    domProps: {
      "value": null
    }
  }, [_vm._v("Todos")]), _vm._v(" "), _vm._l((_vm.modules), function(module) {
    return _c('option', {
      key: module,
      domProps: {
        "value": ((module.type) + "." + (module.identifier))
      }
    }, [_vm._v(_vm._s(_vm.$t(module.type).label) + " " + _vm._s(_vm.$t(module.identifier).label))])
  })], 2)]), _vm._v(" "), _c('form-group', {
    attrs: {
      "label": _vm.$t('level.label')
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.options.level),
      expression: "options.level"
    }],
    staticClass: "form-select",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.options, "level", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    domProps: {
      "value": null
    }
  }, [_vm._v("Todos")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "critical"
    }
  }, [_vm._v(_vm._s(_vm.$t("level.critical.label")))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "warning"
    }
  }, [_vm._v(_vm._s(_vm.$t("level.warning.label")))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "info"
    }
  }, [_vm._v(_vm._s(_vm.$t("level.info.label")))])])]), _vm._v(" "), _c('form-group', {
    attrs: {
      "label": "Data"
    }
  }, [_c('el-date-picker', {
    attrs: {
      "type": "datetimerange",
      "format": "dd/MM/yyyy HH:mm",
      "start-placeholder": "Data Inicial",
      "end-placeholder": "Data Final"
    },
    model: {
      value: (_vm.updatedDate),
      callback: function($$v) {
        _vm.updatedDate = $$v
      },
      expression: "updatedDate"
    }
  })], 1)], 1), _vm._v(" "), (_vm.dataLogs.length) ? _c('div', {
    staticClass: "l-col-12@md"
  }, [_c('time-line', {
    attrs: {
      "items": _vm.dataLogs
    }
  })], 1) : _c('div', {
    staticClass: "l-col u-textCenter"
  }, [_c('panel', [_vm._v("Nenhum histórico encontrado.")])], 1)], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1b9d7b11","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/Log/List.vue
// module id = 2955
// module chunks = 0